import { Grid } from "@mui/material";
import { AddressFields } from "@shared";
import { ClientPersonalDataMaxLength } from "@shared";
import { FormikProps } from "formik";

import { EditClientType } from "@/pages/clients/client/components/tabs/master-data-tab/views/personal-data/EditClient.types";
import { useTranslation } from "@/translations";

import { ContactDetailRows } from "./components/contact-detail-rows/ContactDetailRows";

interface Props {
  formik: FormikProps<EditClientType>;
}

export function PersonalDataAddressSection({ formik }: Props) {
  const { t } = useTranslation();

  return (
    <Grid container rowSpacing={2} columnSpacing={2}>
      <AddressFields
        formik={formik}
        streetField="street"
        houseNumberField="houseNumber"
        zipCodeField="zipCode"
        cityField="city"
        countryField="country"
        streetMaxLength={ClientPersonalDataMaxLength.street}
        required={{ street: true, houseNumber: true, zipCode: true, city: true, country: true }}
      />

      <ContactDetailRows
        formik={formik}
        fieldName="emailContactDetails"
        valueLabel={t("clients.create.email")}
        addLabel={t("clients.client.masterData.personalData.addEmail")}
        removeLabel={t("clients.client.masterData.personalData.removeEmail")}
      />

      <ContactDetailRows
        formik={formik}
        fieldName="phoneContactDetails"
        valueLabel={t("clients.create.phone")}
        addLabel={t("clients.client.masterData.personalData.addPhoneNumber")}
        removeLabel={t("clients.client.masterData.personalData.removePhoneNumber")}
      />
    </Grid>
  );
}
